import { Link } from 'react-router-dom';
import { company } from '../data/company';
import { downloadFile } from '../utils/utils';
import Icon, { type IconName } from './Icon';

interface Action {
  icon: IconName;
  label: string;
  value: string;
  href?: string;
  to?: string;
}

export default function CTASection() {
  const actions: Action[] = [
    { icon: 'mail', label: 'Email', value: company.email, href: `mailto:${company.email}` },
    { icon: 'phone', label: 'Call', value: company.phones[0], href: `tel:${company.phones[0].replace(/\s/g, '')}` },
    { icon: 'flask', label: 'Samples', value: 'Request a sample', to: '/contact' },
    { icon: 'pin', label: 'Visit', value: 'Ankleshwar, Gujarat', to: '/contact' },
  ];

  return (
    <section className="bg-primary-deep text-white">
      <div className="container-page py-20">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr] lg:items-end">
          <div>
            <div className="kicker text-secondary-light">
              <span className="text-sm tracking-normal text-secondary-light">—</span>
              <span>Let's work together</span>
            </div>
            <h2 className="mt-5 text-3xl font-semibold leading-[1.1] text-white sm:text-4xl lg:text-[2.75rem]">
              Ready to find the right chemistry for your formulation?
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-8 text-white/75">
              Our technical team helps you select products, request samples and plan reliable supply.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/product-finder" className="btn-gold">
                Open Product Finder <Icon name="arrow" className="h-4 w-4" />
              </Link>
              <button
                type="button"
                onClick={() => downloadFile(company.productGuide.fileUrl, company.productGuide.fileName)}
                className="btn border border-white/25 bg-transparent text-white hover:bg-white/10"
              >
                <Icon name="download" className="h-4 w-4" /> Product Guide
              </button>
            </div>
          </div>

          <div className="divide-y divide-white/10 border-t border-white/10">
            {actions.map((a) => {
              const content = (
                <span className="group flex items-center gap-4 py-4">
                  <Icon name={a.icon} className="h-5 w-5 flex-none text-secondary-light" />
                  <span className="flex-1">
                    <span className="block text-xs uppercase tracking-wider text-white/50">{a.label}</span>
                    <span className="block text-sm font-medium text-white">{a.value}</span>
                  </span>
                  <Icon name="arrow" className="h-4 w-4 text-white/40 transition-all group-hover:translate-x-1 group-hover:text-white" />
                </span>
              );
              return a.to ? (
                <Link key={a.label} to={a.to} className="block">
                  {content}
                </Link>
              ) : (
                <a key={a.label} href={a.href} className="block">
                  {content}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
